import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/classnames/index.js';
import 'react';
import '@cheetahdigital/console-kit-cx';
import 'semantic-ui-react';
import CenterEllipsis from '../../../shared/components/CenterEllipsis/index.js';
import 'react-dom';
import styles from './index.module.scss.js';
import KeyIcon from './KeyIcon.js';

var ProfileIcon = function (_a) {
    var _b, _c;
    var _d = _a.firstName, firstName = _d === void 0 ? "" : _d, _e = _a.lastName, lastName = _e === void 0 ? "" : _e, image = _a.image, businessUnit = _a.businessUnit, size = _a.size, isImpersonate = _a.isImpersonate;
    var hasName = !!firstName || !!lastName;
    return (jsxs("div", __assign({ className: styles.container }, { children: [jsxs("div", __assign({ className: classNames("cd profile-icon", styles.profileIcon, size && styles.profileIconSmall, image && styles.noBackgroundColor) }, { children: [image && (jsx("img", { src: image, alt: "Profile", className: styles.profileImage }, void 0)), !image && (jsxs("span", __assign({ className: styles.iconLabel }, { children: [hasName &&
                                "".concat((_b = firstName.charAt(0)) === null || _b === void 0 ? void 0 : _b.toUpperCase(), "\n            ").concat((_c = lastName.charAt(0)) === null || _c === void 0 ? void 0 : _c.toUpperCase()), !hasName && "NA"] }), void 0)), isImpersonate && jsx(KeyIcon, { className: styles.keyIcon }, void 0)] }), void 0), businessUnit && (jsx("div", __assign({ className: styles.businessUnit }, { children: jsx(CenterEllipsis, { children: businessUnit }, void 0) }), void 0))] }), void 0));
};

export { ProfileIcon as default };
